import React, { useState, useRef, useEffect } from "react";
import { ImageGalleryProps } from "../../types/interface";
import blankImages from "../../assets/icons/inference.svg";
import { useTest } from "./TestContext";
import downloadButton from "../../assets/icons/download.svg";
import { downloadTest } from "../../store/slice/ProjectTestSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store/store";
import { LinearProgress, ListItem, List } from "@mui/material";
import { AxiosProgressEvent } from "axios";
import { toast } from "react-toastify";
export interface LabelDetail{
  labelName:string;
  count:number;
}


const BlankOther: React.FC<ImageGalleryProps> = ({ id }) => {
  const { nextResult, modelOther, compare, sliderValueOther } = useTest();
  const [progress, setProgress] = useState<number>(0);
  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const dispatch: AppDispatch = useDispatch();
  const [isZoomed, setIsZoomed] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

  const handleDownloadImage = (base64Image: string) => {
    const link = document.createElement("a");
    link.href = `data:image/jpeg;base64,${base64Image}`; // Change the image type if needed (jpeg, png, etc.)
    link.download = "image.jpg"; // The file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const [labelDetails,setLabelDetails] = useState<LabelDetail[]>([]);

  const handleDownload = async (trainingId: string) => {
    setIsDownloading(true);
    setProgress(0);

    const resultAction = await dispatch(
      downloadTest({
        trainingId,
        options: {
          onDownloadProgress: (progressEvent: AxiosProgressEvent) => {
            const total = progressEvent.total || 0;
            const current = progressEvent.loaded || 0;
            const percentage = Math.floor((current / total) * 100);
            setProgress(percentage);
          },
        },
      })
    );

    setIsDownloading(false);

    if (downloadTest.fulfilled.match(resultAction)) {
      toast.success(`Download completed`, {
        position: "bottom-right",
      });
    } else {
      const errorMessage =
        typeof resultAction.error.message === "string"
          ? resultAction.error.message
          : "An error occurred during download";
      toast.error(errorMessage, {
        position: "bottom-right",
      });
    }
  };


  const ImagePopup = ({ imageSrc, onClose }: { imageSrc: string; onClose: () => void }) => {
    const [zoomLevel, setZoomLevel] = useState(1);
    const [dragging, setDragging] = useState(false);
    const [dragStart, setDragStart] = useState<{ x: number; y: number } | null>(null);
    const [imagePosition, setImagePosition] = useState({ x: 0, y: 0 });
    const containerRef = useRef<HTMLDivElement | null>(null);
    const imageRef = useRef<HTMLImageElement | null>(null);

    // Handle zoom with mouse wheel
    const handleWheel = (event: React.WheelEvent) => {
      event.preventDefault();
      const zoomIncrement = 0.1;
      const newZoom = event.deltaY < 0 ? Math.min(zoomLevel + zoomIncrement, 3) : Math.max(zoomLevel - zoomIncrement, 1);
      setZoomLevel(newZoom);
    };
  
    // Reset zoom and position
    const resetZoom = () => {
      setZoomLevel(1);
      setImagePosition({ x: 0, y: 0 });
    };
  
    // Ensure the container is scrollable when zoomed beyond the viewport
    useEffect(() => {
      if (containerRef.current && imageRef.current) {
        const container = containerRef.current;
        const image = imageRef.current;
  
        // Calculate offsets to center the image
        const offsetX = (container.clientWidth - image.naturalWidth * zoomLevel) / 2;
        const offsetY = (container.clientHeight - image.naturalHeight * zoomLevel*zoomLevel*5.0) / 2;
  
        setImagePosition({
          x: Math.max(offsetX, 0), // Prevent going out of bounds horizontally
          y: Math.max(offsetY, 0), // Prevent going out of bounds vertically
        });
      }
    }, [zoomLevel]);
  
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        {/* Image Container */}
        <div
          ref={containerRef}
          onWheel={handleWheel}
          style={{
            position: "relative",
            overflow: "auto",
            width: "100vw",
            height: "100vh",
            cursor: dragging ? "grabbing" : "default",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={imageSrc}
            alt="Zoomed"
            style={{
              transform: `scale(${zoomLevel}) translate(${imagePosition.x}px, ${
                imagePosition.y}px)`,
              transformOrigin: "center",
              transition: dragging ? "none" : "transform 0.4s ease-in-out",
              paddingTop: `${zoomLevel*zoomLevel*zoomLevel*2.4}px`,
              paddingBottom: `2px`,
              maxWidth: "none",
              maxHeight: "none",
            }}
          />
        </div>
  
        {/* Controls */}
        <div
          style={{
            position: "absolute",
            bottom: "20px",
            display: "flex",
            justifyContent: "center",
            gap: "15px",
          }}
        >
          {/* Zoom In */}
          <button
            onClick={() => setZoomLevel((prev) => Math.min(prev + 0.1, 3))}
            style={{
              width: "35px",
              height: "35px",
              background: "#fff",
              borderRadius: "50%",
              border: "none",
              cursor: "pointer",
              fontSize: "20px",
            }}
          >
            +
          </button>
  
          {/* Zoom Out */}
          <button
            onClick={() => setZoomLevel((prev) => Math.max(prev - 0.1, 1))}
            style={{
              width: "35px",
              height: "35px",
              background: "#fff",
              borderRadius: "50%",
              border: "none",
              cursor: "pointer",
              fontSize: "18px",
            }}
          >
            -
          </button>
  
          {/* Reset */}
          <button
            onClick={resetZoom}
            style={{
              width: "35px",
              height: "35px",
              background: "#fff",
              borderRadius: "50%",
              border: "none",
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            Fit
          </button>
  
          {/* Close */}
          <button
            onClick={onClose}
            style={{
              width: "35px",
              height: "35px",
              background: "#fff",
              borderRadius: "50%",
              border: "none",
              cursor: "pointer",
              fontSize: "18px",
            }}
          >
            ✖
          </button>
        </div>
      </div>
    );
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const openPopup = (imageSrc: string) => {
    setSelectedImage(imageSrc);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedImage("");
  };

  return (
    <>
      {isDownloading && (
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            backgroundColor: "#e0e0e0", // Background color for the track
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#4caf50", // Green color for the progress bar
            },
          }}
        />
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          overflow: "scroll",
          minHeight: "calc(100vh - 320px)",
          maxHeight: "calc(100vh - 320px)",
          position: "relative", // Added for absolute positioning of the download button
          backgroundColor: isDownloading ? "lightgrey" : "transparent", // Light grey background if downloading
        }}
      >
          { (labelDetails.length>0) ? (
              <div
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "60px",
                  padding: "10px",
                  backgroundColor: "#838983", // Green background for the button
                  border: "none", // No border
                  borderRadius: "5px", // Rounded corners
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center", // Center vertically
                  justifyContent: "center", // Center horizontally
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <button
                  style={{ background: "none", border: "none", color: "white" }}
                >
                  Label
                </button>
        
                {isHovered && (
                  <List
                    sx={{
                      position: "absolute",
                      top: "40px",
                      right: "0",
                      backgroundColor: "#fff",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      borderRadius: "5px",
                      padding: "5px 10px",
                      width: "max-content",
                      zIndex: 1000,
                    }}
                  >
                    {labelDetails&&(
                    labelDetails.map((label:any, index) => (
                     
                                    <ListItem
                        key={index} // ✅ Always use a unique key when mapping
                        sx={{
                          cursor: "pointer",
                          "&:hover": { backgroundColor: "#f0f0f0" },
                        }}
                      >
                        {/* <span
                          style={{
                            width: "18px",
                            height: "18px",
                            background: labelDetails.color,
                            borderRadius: "3px",
                            display: "inline-block",
                          }}
                        ></span> */}
                      
                        {label.labelName} ({label.count})
                      </ListItem>
                    ))
                    )}
                  </List>
                )}
              </div>
            ):("")}
        {isDownloading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent overlay
              zIndex: 1, // Ensure overlay is above other content
              pointerEvents: "all", // Block pointer events
            }}
          />
        )}

        {nextResult?.trainingId ? (
          <button
            onClick={() => {
              
            }}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              padding: "10px",
              backgroundColor: "#838983", // Green background for the button
              color: "white", // White text
              border: "none", // No border
              borderRadius: "5px", // Rounded corners
              cursor: "pointer",
              display: "flex",
              alignItems: "center", // Center vertically
              justifyContent: "center", // Center horizontally
            }}
          >
            <img
              src={downloadButton}
              alt="download button"
              style={{
                width: "15px", // Adjust to fit button width
                height: "auto", // Maintain aspect ratio
                maxWidth: "100px", // Set max width for image size
                // objectFit: "contain",
              }}
            />
          </button>
        ) : (
          ""
        )}
        {/* Download button */}

        {nextResult && modelOther && sliderValueOther ? (
         <>
            <iframe src={nextResult?.data?.InferenceLink}  title="Inference Viewer"
        width="100%"
        height="100%"
        style={{ 
          display: "block",
          border: "none",
          minHeight: compare ? "calc(100vh - 320px)" : "calc(100vh - 260px)",
          maxHeight: compare ? "calc(100vh - 320px)" : "calc(100vh - 260px)",
         }}></iframe>
          </>
        ) : (
          <>
            <img src={blankImages} alt="blanks" style={{ maxWidth: "100%" }} />
          </>
        )}
      </div>

      {isPopupOpen && <ImagePopup imageSrc={selectedImage} onClose={closePopup} />}
      
    </>
  );
};

export default BlankOther;
